import Cookies from 'js-cookie'

const CookieKey = 'isLogin'

export function getLogin() {
  return Cookies.get(CookieKey)
}

export function setLogin() {
  Cookies.set(CookieKey, 'true')
}

export function removeLogin() {
  return Cookies.remove(CookieKey)
}
